export default __webpack_public_path__ + "images/Dominican.f759c8.jpg";